import { baseURLFromEnv, defaultClientConfig } from "@/api/asb/client";
import axios from "axios";
import { handleServiceError, tokenInterceptor } from "@/api/utils";

export const taskmgrJSONAPIClient = axios.create({
  ...defaultClientConfig,
  baseURL: baseURLFromEnv("taskmgr/v1/"),
  headers: {
    "Content-Type": "application/vnd.api+json"
  }
});

export const taskmgrClient = axios.create({
  ...defaultClientConfig,
  "Content-Type": "application/json",
  baseURL: baseURLFromEnv("taskmgr/v1/")
});

taskmgrClient.interceptors.request.use(tokenInterceptor);
taskmgrJSONAPIClient.interceptors.request.use(tokenInterceptor);

export default {
  handleError: error => handleServiceError("Taskmgr", error)
};
